import React from 'react';
import { ChipBase } from '../chip-base/chip-base';
export const ChipInput = ({ content, ...restProps }) => {
    return (React.createElement(ChipBase, { size: "m", type: "default", content: [
            {
                text: content,
                style: 'regular',
            },
        ], variant: "input", ...restProps }));
};
//# sourceMappingURL=chip-input.js.map